
    import './styles.scoped.css';
    export default {
  "grid": "awsui_grid_14yj0_1eroa_94",
  "no-gutters": "awsui_no-gutters_14yj0_1eroa_108",
  "grid-column": "awsui_grid-column_14yj0_1eroa_112",
  "colspan-1": "awsui_colspan-1_14yj0_1eroa_121",
  "push-1": "awsui_push-1_14yj0_1eroa_125",
  "pull-1": "awsui_pull-1_14yj0_1eroa_128",
  "colspan-2": "awsui_colspan-2_14yj0_1eroa_131",
  "push-2": "awsui_push-2_14yj0_1eroa_135",
  "pull-2": "awsui_pull-2_14yj0_1eroa_138",
  "colspan-3": "awsui_colspan-3_14yj0_1eroa_141",
  "push-3": "awsui_push-3_14yj0_1eroa_145",
  "pull-3": "awsui_pull-3_14yj0_1eroa_148",
  "colspan-4": "awsui_colspan-4_14yj0_1eroa_151",
  "push-4": "awsui_push-4_14yj0_1eroa_155",
  "pull-4": "awsui_pull-4_14yj0_1eroa_158",
  "colspan-5": "awsui_colspan-5_14yj0_1eroa_161",
  "push-5": "awsui_push-5_14yj0_1eroa_165",
  "pull-5": "awsui_pull-5_14yj0_1eroa_168",
  "colspan-6": "awsui_colspan-6_14yj0_1eroa_171",
  "push-6": "awsui_push-6_14yj0_1eroa_175",
  "pull-6": "awsui_pull-6_14yj0_1eroa_178",
  "colspan-7": "awsui_colspan-7_14yj0_1eroa_181",
  "push-7": "awsui_push-7_14yj0_1eroa_185",
  "pull-7": "awsui_pull-7_14yj0_1eroa_188",
  "colspan-8": "awsui_colspan-8_14yj0_1eroa_191",
  "push-8": "awsui_push-8_14yj0_1eroa_195",
  "pull-8": "awsui_pull-8_14yj0_1eroa_198",
  "colspan-9": "awsui_colspan-9_14yj0_1eroa_201",
  "push-9": "awsui_push-9_14yj0_1eroa_205",
  "pull-9": "awsui_pull-9_14yj0_1eroa_208",
  "colspan-10": "awsui_colspan-10_14yj0_1eroa_211",
  "push-10": "awsui_push-10_14yj0_1eroa_215",
  "pull-10": "awsui_pull-10_14yj0_1eroa_218",
  "colspan-11": "awsui_colspan-11_14yj0_1eroa_221",
  "push-11": "awsui_push-11_14yj0_1eroa_225",
  "pull-11": "awsui_pull-11_14yj0_1eroa_228",
  "colspan-12": "awsui_colspan-12_14yj0_1eroa_231",
  "push-12": "awsui_push-12_14yj0_1eroa_235",
  "pull-12": "awsui_pull-12_14yj0_1eroa_238",
  "push-0": "awsui_push-0_14yj0_1eroa_241",
  "pull-0": "awsui_pull-0_14yj0_1eroa_244",
  "offset-1": "awsui_offset-1_14yj0_1eroa_247",
  "offset-2": "awsui_offset-2_14yj0_1eroa_250",
  "offset-3": "awsui_offset-3_14yj0_1eroa_253",
  "offset-4": "awsui_offset-4_14yj0_1eroa_256",
  "offset-5": "awsui_offset-5_14yj0_1eroa_259",
  "offset-6": "awsui_offset-6_14yj0_1eroa_262",
  "offset-7": "awsui_offset-7_14yj0_1eroa_265",
  "offset-8": "awsui_offset-8_14yj0_1eroa_268",
  "offset-9": "awsui_offset-9_14yj0_1eroa_271",
  "offset-10": "awsui_offset-10_14yj0_1eroa_274",
  "offset-11": "awsui_offset-11_14yj0_1eroa_277",
  "restore-pointer-events": "awsui_restore-pointer-events_14yj0_1eroa_281"
};
  